<sn-form [form]="form" [fields]="formFields" [model]="formModel" [options]="formOptions"></sn-form>
